module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }